import { Pipe, PipeTransform } from '@angular/core';
import { has, findIndex } from 'lodash';

@Pipe({
  name: 'userInterestColor',
  pure: false
})

export class UserInterestPipe implements PipeTransform {

  transform(id: string, clientCategories: any, clientConfig: any, type: string = 'icon') {
    let itemIndex = findIndex(clientCategories, (category: any) => {
      return category.id === id;
    });
    let item = clientCategories[itemIndex];
    if (has(item, 'isSelect') && item['isSelect'] === true) {
      return type === 'container' ? clientConfig.style_first_color : clientConfig.style_contrast;
    }
    return type === 'container' ? "grey-200" : "b2b2b4";
  }
}


// WEBPACK FOOTER //
// ./src/pipes/user-interest.ts